<template>
    <a-modal
        centered
        title="发票信息审核"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="360"
        :confirmLoading="submitting"
        :after-close="after_close"
    >
        <a-form-model>
            <a-form-model-item>
                <a-radio-group v-model="form.audit_status" button-style="solid">
                    <a-radio-button :value="1">
                        通过
                    </a-radio-button>
                    <a-radio-button :value="-1">
                        拒绝
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="拒绝原因" v-if="form.audit_status === -1">
                <a-textarea v-model="form.invoice_msg"></a-textarea>
            </a-form-model-item>

        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        audit_status: null,
        invoice_msg: null,
        invoice_id: null,
    };
    export default {
        props: {
            visible: false,
            audit_status: {
                default: 1,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                form: null,
            };
        },
        watch: {
            visible() {
                this.form.audit_status = this.audit_status;
                this.form.invoice_id = this.record.id
            },
        },
        created(){
            this.form = JSON.parse(JSON.stringify(init_form))
        },
        methods: {
            on_ok() {
                this.submitting = true;
                this.form.review_id = this.record.id;
                this.$http
                    .post(`/finance/invoice_review/audit`, this.form)
                    .then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                            this.on_cancel();
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered:true,
                                content: res.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
            },
            on_cancel() {
                this.$emit("close");
            },
        },
    };
</script>
<style lang="less" scoped>
    .r-checkbox {
        cursor: pointer;
        margin-bottom: 12px;
    }
    .ids {
        font-size: 12px;
    }
</style>
